export default __webpack_public_path__ + "static/media/icon_link.74740934.svg";